import React from 'react';
import { Box, Button, Flex, Heading, ScrollArea, Table, Text } from '@radix-ui/themes';
import { observer } from 'mobx-react-lite';

import { BusyIndicator } from 'shared/components';
import { useTelegramStats } from './telegram-stats.provider';

const TelegramStatsView = () => {
   const telegramStats = useTelegramStats();

   React.useEffect(() => {
      if (telegramStats.loadTelegramStatsState.status === 'idle') {
         telegramStats.loadTelegramStats();
      }
   }, [telegramStats]);

   if (telegramStats.isLoading) {
      return (
         <Flex className="main-analytics__state" align="center" justify="center" direction="column" gap="3">
            <BusyIndicator />
            <Text color="gray">Loading Telegram stats</Text>
         </Flex>
      );
   }

   if (telegramStats.isError || !telegramStats.data) {
      return (
         <Flex className="main-analytics__state" align="center" justify="center" direction="column" gap="3">
            <Text color="red">Could not load Telegram stats.</Text>
            <Button size="2" onClick={() => telegramStats.loadTelegramStats()}>
               Retry
            </Button>
         </Flex>
      );
   }

   return (
      <Box className="main-analytics__telegram">
         <Flex className="main-analytics__telegram-header" justify="between" align="center" gap="3">
            <Heading as="h2" size="4" weight="medium">
               Telegram bot stats
            </Heading>
            <Text size="2" color="gray">
               Total metrics: {telegramStats.rows.length}
            </Text>
         </Flex>

         <ScrollArea scrollbars="both" type="always" className="main-analytics__telegram-scroll">
            <Box className="main-analytics__telegram-table-wrap">
               <Table.Root size="3" layout="auto" variant="surface">
                  <Table.Header>
                     <Table.Row>
                        <Table.ColumnHeaderCell>Metric</Table.ColumnHeaderCell>
                        <Table.ColumnHeaderCell align="right">Value</Table.ColumnHeaderCell>
                     </Table.Row>
                  </Table.Header>
                  <Table.Body>
                     {telegramStats.rows.map((row) => (
                        <Table.Row key={row.key}>
                           <Table.Cell>{row.label}</Table.Cell>
                           <Table.Cell align="right">
                              <Text weight="medium">{row.value}</Text>
                           </Table.Cell>
                        </Table.Row>
                     ))}
                  </Table.Body>
               </Table.Root>
            </Box>
         </ScrollArea>
      </Box>
   );
};

export const FeatureTelegramStatsView = observer(TelegramStatsView);
